module.exports = __webpack_public_path__ + "static/waterdamage-2e90ff2a76ffb590ed69f1e34d936a1a.jpg";